import { Grid } from '@material-ui/core';
import Box from '@mui/material/Box';
import { Button } from "@mui/material";
import ContractsContext from '../../context/ContractsContext/ContractsContext';
import { useContext, useState, ChangeEvent } from 'react';
import CustomTabs from "../../components/Collaborators/Tab/CustomTabs";
import CustomTab from "../../components/Collaborators/Tab/CustomTabMain";
import {Contract} from '../../components/Contracts/Contract';
import styles from './Contracts.module.css';
import {openExpiredContracts} from '../../context/ContractsContext/Actions';
import {ExpiredContracts} from '../../components/Contracts/Modal/ExpiredContracts';
import { server } from "../../global/server";
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import Swal from 'sweetalert2';

export const ShowContracts = () => {
    const [tab, setTab] = useState(0);
    const {dispatch} = useContext(ContractsContext);
        
    const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
        setTab(newValue);
        localStorage.setItem("currentPill", String(newValue));
    };

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;

        const formData = new FormData();
        Array.from(e.target.files).forEach((file) => {
            formData.append("templates", file);
        });

        let uploadedFiles: string[] = [];

        try {
            // Mostrar SweetAlert con progreso
            Swal.fire({
                title: 'Subiendo templates...',
                html: '0%',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const urlContracts = `${server}/Contracts/uploadsTemplates`;

            await axios.post(urlContracts, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
                    Swal.getHtmlContainer()!.innerHTML = `<b>${percent}%</b>`;
                }
            });

            // Guardar nombres de archivos
            uploadedFiles = Array.from(e.target.files).map(f => f.name);

            Swal.close();

            // Mostrar SweetAlert con la lista de archivos subidos
            Swal.fire({
                title: 'Templates subidos con éxito 🚀',
                html: `<ul style="text-align:left;">${uploadedFiles.map(f => `<li>${f}</li>`).join('')}</ul>`,
                icon: 'success',
                confirmButtonText: 'Cerrar'
            });

        } catch (err) {
            console.error(err);
            Swal.fire({
                title: 'Error al subir los templates ❌',
                text: 'Ocurrió un error al intentar subir los archivos',
                icon: 'error',
                confirmButtonText: 'Cerrar'
            });
        }

        // reset input
        e.target.value = "";
    };

    const handleDownload = async () => {
         try {
    Swal.fire({
      title: "Generando ZIP...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });
    const nameFolder='templatesContracts'
     const urlContractsDown = `${server}/Contracts/downloadTemplatesContracts`;
    const response = await axios.post(urlContractsDown, {
      nameFolder,      
    }, { responseType: "blob" });

    // crear enlace para descargar
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "templatesContratos.zip");
    document.body.appendChild(link);
    link.click();
    link.remove();

    Swal.close();
    Swal.fire({
      icon: "success",
      title: "ZIP descargado ✅"
    });

  } catch (error) {
    console.error(error);
    Swal.fire({
      icon: "error",
      title: "Error al generar ZIP ❌",
     // text: error?.response?.data?.error || error.message
    });
  }
    }

    return (
        <div>
            <Box mt={3} ml={5} className="Title">Contratos</Box>
            <Box p={5} pb={3} pt={0}>
                <div style={{ display: "flex" }}>
                    <Grid container justify="flex-start">
                        <CustomTabs
                            value={tab}
                            onChange={handleChange}
                            aria-label="simple tabs example"
                        >
                            <CustomTab label="Generación de contratos" value={0} />
                        </CustomTabs>
                    </Grid>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <button
                            className={styles.botonAgregar}
                            onClick={() => openExpiredContracts({}, dispatch)}
                        >
                            <div className={styles.iconoAgegar}></div>
                            <div className={styles.textoBotonAgregar}>Contratos vencidos/por vencer</div>            
                        </button>
                        <Button
                            variant="contained"
                            component="label"
                            sx={{
                                width: "38px",
                                height: "38px",
                                backgroundColor: "#fabb00",
                                border: "none",
                                borderRadius: "8px !important",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "#093c5d",
                                "&:hover": { backgroundColor: "#fabb00" }
                            }}
                        >
                            <UploadIcon />
                            <input type="file" multiple hidden onChange={handleFileChange} />
                        </Button>
                        <Button
                        variant="contained"
                        sx={{
                            width: "38px",
                            height: "38px",
                            backgroundColor: "#fabb00",
                            border: "none",
                            borderRadius: "8px !important",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#093c5d",
                            "&:hover": { backgroundColor: "#fabb00" }
                        }}
                        onClick={handleDownload} // aquí defines la función de descarga
                    >
                        <DownloadIcon />
                    </Button>

                    </div>
                </div>
            </Box>

            <div className="contenedor2">
                {tab === 0 && <Contract value={tab} index={0} />}
            </div>
            <ExpiredContracts/>
        </div>
    );
};
